module.exports = __webpack_public_path__ + "static/media/inicio.5d3aa76a.jpg";